import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  disclosure_terms_preferential_treatment_flag: {
    name: 'Concerning different disclosure/reporting to investors',
    order: 216,
    letter: 'A'
  },
  liquidity_terms_preferential_treatment_flag: {
    name: 'Concerning different investor liquidity terms',
    order: 217,
    letter: 'A'
  },
  fee_terms_preferential_treatment_flag: {
    name: 'Concerning different fee terms for investors',
    order: 218,
    letter: 'A'
  },
  other_terms_preferential_treatment_flag: {
    name: 'Preferential treatment other than specified above',
    order: 219,
    letter: 'A'
  }
};

export function Treatment({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_PREFERENTIAL_TREATMENT,
    onChangeFund,
    schema: schema.INVESTOR_PREFERENTIAL_TREATMENT,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_PREFERENTIAL_TREATMENT?.field_names || [],
    columnLables,
    tableName: 'INVESTOR_PREFERENTIAL_TREATMENT',
    funds,
    isMultiFunds
  });

  return (
    <Table
      id="fca-reporttables-treatment-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
